
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-started/partnerships",
      function () {
        return require("private-next-pages/get-started/partnerships.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-started/partnerships"])
      });
    }
  